import axios, { type AxiosInstance } from 'axios';

const API_BASE = import.meta.env.VITE_API_URL ?? '';

export const adminClient: AxiosInstance = axios.create({
  baseURL: `${API_BASE}/api/admin/v1`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30_000,
});

const TOKEN_KEY = 'growthpilot_admin_token';

export function getAdminToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAdminToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

adminClient.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

adminClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      clearAdminToken();
    }
    return Promise.reject(error);
  },
);
